module.exports = __webpack_public_path__ + "./Sharon_color_b39bf83547a0bb6edc5a72cb693fc833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Sharon_color.jpg
// module id = 606
// module chunks = 0